













import { Component, Vue, Provide } from "vue-property-decorator";
import NewsItem from "@/components/NewsItem.vue";
import { ColumnsConfig } from "@/common/BaseConfig";
import native from "@/common/Native";
import request from "@/api/index";
import { INewsItem } from "@/api/types.d";
import { List, PullRefresh } from "vant";
@Component({
  components: {
    NewsItem,
    VanList: List,
    VanPullRefresh: PullRefresh
  }
})
export default class NewsListPage extends Vue {
  columnId: string = "";
  title: string = "";
  newsList: INewsItem[] = [];
  loading: boolean = false;
  finished: boolean = false;
  lastItem?: INewsItem;
  isLoading: boolean = false;
  mounted() {
    this.init();
  }
  init() {
    this.columnId = (this.$route.query.columnId as string) || "1151";
    this.title = this.$route.query.title as string;
    this.setTitle();
  }
  setTitle() {
    if (this.title) {
      native.setTile(this.title);
    }
  }
  getNewsList(isClear: boolean = false) {
    const lastId = this.lastItem ? this.lastItem!.id : undefined;
    const lastSortNo = this.lastItem ? this.lastItem!.sortNo : undefined;
    const lastOnlineTime = this.lastItem
      ? this.lastItem!.onlineTime
      : undefined;
    request
      .getNews(
        false,
        this.columnId.split(".").lastChild,
        lastId,
        lastSortNo,
        lastOnlineTime
      )
      .then(result => {
        if (isClear) {
          this.finished = false;
          this.newsList = [];
        }
        if (!result.data.news || result.data.news.length === 0) {
          this.finished = true;
        } else {
          this.isLoading = false;
          this.loading = false;
          this.newsList = this.newsList.concat(result.data.news);
          this.lastItem = result.data.news.lastChild;
        }
      });
  }
  onLoad() {
    this.getNewsList();
  }
  onRefresh() {
    this.lastItem = undefined;
    this.getNewsList(true);
  }
}
